import { render, staticRenderFns } from "./downloadImage.vue?vue&type=template&id=13a1b321&scoped=true"
import script from "./downloadImage.vue?vue&type=script&lang=js"
export * from "./downloadImage.vue?vue&type=script&lang=js"
import style0 from "./downloadImage.vue?vue&type=style&index=0&id=13a1b321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1b321",
  null
  
)

export default component.exports